//chatData,点击的左侧联系人的信息
// sendData,选择要发送话术的内容
// chatId 选择要发送话术的id
import React, {useState, useEffect, useRef, useImperativeHandle, forwardRef, useContext} from "react"
import ZkModal from "../../../common/modal/zkModal";
import {Button, Divider} from "antd";
import wxappLink from "../../image/messageList/wxappLink.png";
import audioPause from "../../iconfont/audio/audioPause.png";
import videoHao from "../../image/messageList/videoHao.png";
import sendSingle from "../../image/chat/sendSingle.png";
import ZkFormItem from "../../../common/form/zkFormItem";
import Util from "../../../public/utils";
import TaskposterUtil from "../../../ext/taskpost/taskposter_util";
import audioPlaying from "../../iconfont/audio/playing.gif";
import txt from "../../image/file/txt.png";
import ppt from "../../image/file/ppt.png";
import word from "../../image/file/word.png";
import excel from "../../image/file/excel.png";
import pdf from "../../image/file/pdf.png";
import zip from "../../image/file/zip.png";
import unknownFile from "../../image/messageList/unknownFile.png";
import videoHaoInmodal from "../../../im/image/messageList/videoHao.png"
import CloudApi from "../../../cloud/cloud_api";
import {MyContext} from "../../chatSider";
import md5 from "js-md5";
import {nanoid} from "nanoid";
// let newDataList=[]
// let sendIndex = 0
const SendPopUp = forwardRef((props, ref) => {
    const [chatData, setChatData] = useState({})//左侧联系人的数据消息
    const [sendData, setSendData] = useState([])//发送的数据
    const [chatId, setChatId] = useState(null)//发送的Id
    const [loading, setLoading] = useState(false)
    const [sendIndex, setSendIndex] = useState(null)
    const sendPopUpModalRef = useRef(null)
    const talkLivContext = useContext(MyContext)
    useImperativeHandle(ref, () => ({
        openSendPopUp: openSendPopUp,
        // getBack:getBack
    }))

    //点击打开弹框
    function openSendPopUp(chatData, sendData, chatId) {
        setSendIndex(null)
        setChatData(chatData) //左侧的联系人的消息
        setSendData(sendData) //发送的数据
        setChatId(chatId)
        sendPopUpModalRef.current.show()
    }

    const fileImg = (fileName) => {
        if (fileName.indexOf('txt') != -1) {
            return txt
        } else if (fileName.indexOf('ppt') != -1) {
            return ppt
        } else if (fileName.indexOf('doc') != -1) {
            return word
        } else if (fileName.indexOf('xlsx') != -1 || fileName.indexOf('xls') != -1 || fileName.indexOf('csv') != -1) {
            return excel
        } else if (fileName.indexOf('pdf') != -1) {
            return pdf
        } else if (fileName.indexOf('zip') != -1 || fileName.indexOf('rar') != -1 || fileName.indexOf('7z') != -1 || fileName.indexOf(' gzip') != -1 || fileName.indexOf(' tar.gz') != -1) {
            return zip
        } else if (fileName.indexOf('video') != -1) {
            return 'video'
        } else if (fileName.indexOf('image') != -1) {
            return 'image'
        } else {
            return unknownFile
        }
    }

    //播放语音
    function onPlay(e) {
        //上面全部暂停， 再播放该次点击的
        let audio = e.currentTarget.getElementsByTagName('audio')[0];
        let audioImg = e.currentTarget.getElementsByClassName('audioImg')[0];
        let rnd = new Date() * 1;
        audio.setAttribute("zkplay", rnd);
        //只要点播放，先把所有的暂停
        let allAudios = document.getElementsByTagName('audio');
        let allAudioImgs = document.getElementsByClassName('audioImg');
        for (let i = 0; i < allAudios.length; i++) {
            let atzkplay = allAudios[i].getAttribute("zkplay");
            if (atzkplay == rnd) {
                continue;
            }
            allAudios[i].pause();
            allAudios[i].currentTime = 0
        }

        for (let i = 0; i < allAudioImgs.length; i++) {
            allAudioImgs[i].src = audioPause
        }

        // 改变播放/暂停图片
        if (audio.paused) {
            audio.play();
            audioImg.src = audioPlaying
        } else {
            audio.pause();
            audio.currentTime = 0
            audioImg.src = audioPause
        }
        audio.addEventListener('ended', () => {
            audioImg.src = audioPause
        }, false);
    }

    //发送话术的弹框确定按钮
    function sendModalQuery() {
        setLoading(true)
        let newSendData = sendData
        let newList = []
        newSendData.forEach((item, index) => {
            let id = md5(chatData.wxid + chatData.chat_wxid + nanoid())
            if (item.type == 1) {
                item.msg_type = 2
                item.id = id
            }
            if (item.type == 2) {
                item.msg_type = 14
                item.id = id
            }
            if (item.type == 3) {
                item.msg_type = 13
                item.id = id
            }
            if (item.type == 4) {
                item.msg_type = 78
                item.id = id
            }
            if (item.type == 5) {
                item.msg_type = 15
                item.id = id
            }
            if (item.type == 6) {
                item.msg_type = 23
                item.id = id
            }
            if (item.type == 7) {
                item.msg_type = 16
                item.id = id
            }
            if (item.type == 8) {
                item.msg_type = 141
                item.id = id
            }

        })
        for (let i = 0; i < sendData.length; i++) {
            //立即执行函数
            let timer = setTimeout(() => {
                newList[0] = sendData[i]
                talkLivContext.talklibSend(newList)
                setSendIndex(i + 1)
                if (i == sendData.length - 1) {
                    setLoading(false)
                    sendPopUpModalRef.current.hide()
                    clearTimeout(timer)
                }
            }, 1000 * i)
        }
        //父组件发送消息的方法 talklibSend
        //自己发送时，追加消息，  MD5id, 发送的类型msgType 发送的文本内容content，文件对象fileData, 解析完毕的混合消息对象mixContents
        CloudApi.getChatLibSend(chatId, (data) => {
        }, () => {
            setLoading(false)
        })
    }

    return (
        <ZkModal ref={sendPopUpModalRef} title={'发送给：'} width={480}
                 footer={[
                     <Button onClick={() => {
                         sendPopUpModalRef.current.hide()
                     }}>取消
                     </Button>,
                     <Button loading={loading} type="primary" onClick={sendModalQuery}>
                         {sendIndex != null ? <>（{sendIndex}/{sendData.length}）</> : ''}
                         确定
                     </Button>,
                 ]}
                 maskClosable={false} className={'modal-right-btn im-setting-modal'}
                 afterClose={null}
                 destroyOnClose
        >
            <div className={'im-file-sender'}>
                {
                    chatData.isRoom == 1 ?
                        <>
                            <img src={chatData.avatar}/>
                            <span>{chatData.name}</span>
                        </>
                        :
                        <>
                            <img src={chatData.avatar}/>
                            <span>{chatData.name}</span>
                            <span
                                className={chatData.corpShortName == '微信' ? 'title-wxName' : 'title-corpName'}>
                                        {chatData.corpShortName ? `@${chatData.corpShortName}` : ''}
                                    </span>
                        </>
                }
            </div>
            <Divider className={'im-file-divider'}/>
            <div className={'send_message_content'}>
                {
                    sendData && sendData.map((item, index) => {
                        return (
                            <div key={index}>
                                {
                                    item.type == 1 ?
                                        <ZkFormItem title={`消息${Util.toChinesNum(index + 1)}`} colon={true}
                                                    titleWidth={'120px'}
                                                    conWidth={'500px'}>
                                            <div className={'zk-text-warp'}
                                                 dangerouslySetInnerHTML={{__html: TaskposterUtil.transformDATA(sendData[index].content.character)}}/>
                                        </ZkFormItem> :
                                        item.type == 2 ?
                                            <ZkFormItem title={`消息${Util.toChinesNum(index + 1)}`} colon={true}
                                                        titleWidth={'120px'} conWidth={'500px'}>
                                                <img src={item.content.picture} style={{width: '100px'}}/>
                                            </ZkFormItem> :
                                            item.type == 3 ?
                                                <ZkFormItem title={`消息${Util.toChinesNum(index + 1)}`} colon={true}
                                                            titleWidth={'120px'} conWidth={'500px'}>
                                                    <div className={'link_demo'}>
                                                        <img src={item.content.linkCover}/>
                                                        <div>
                                                            <div
                                                                className={'link_title'}>{item.content.linkHeadline}</div>
                                                            <div
                                                                className={'link_desc'}>{item.content.linkAbstract}</div>
                                                        </div>
                                                    </div>
                                                </ZkFormItem> :
                                                item.type == 4 ?
                                                    <ZkFormItem title={`消息${Util.toChinesNum(index + 1)}`} colon={true}
                                                                titleWidth={'120px'}
                                                                conWidth={'500px'}>
                                                        <div className={'im-wxapp'}>
                                                            <div className={'wxapp-header'}>
                                                                <img src={item.content.thumburl}/>
                                                                <div>{item.content.title}</div>
                                                            </div>
                                                            <span className={'wxapp-desc'}>{item.content.desc}</span>
                                                            <img src={item.content.coverimgurl}
                                                                 className={'wxapp-big-img'}/>
                                                            <div className={'wxInfo-line'}></div>
                                                            <div className={'wxapp-bottom'}>
                                                                <img src={wxappLink}/>
                                                                <div className={'im-wxcard'}>{'小程序'}</div>
                                                            </div>
                                                        </div>
                                                    </ZkFormItem> :
                                                    item.type == 5 ?
                                                        <ZkFormItem title={`消息${Util.toChinesNum(index + 1)}`}
                                                                    colon={true}
                                                                    titleWidth={'120px'}
                                                                    conWidth={'500px'}>
                                                            <div className={'link_demo'}>
                                                                <img src={fileImg(item.content.uploadFilesName)}/>
                                                                <div>
                                                                    <div
                                                                        className={'link_title'}>{item.content.uploadFilesName}</div>
                                                                    <div
                                                                        className={'link_desc'}>{item.content.dataSize ? (item.content.dataSize / 1000 + 'KB') : '未知大小'}</div>
                                                                </div>
                                                            </div>
                                                        </ZkFormItem> :
                                                        item.type == 6 ?
                                                            <ZkFormItem title={`消息${Util.toChinesNum(index + 1)}`}
                                                                        colon={true}
                                                                        titleWidth={'120px'}
                                                                        conWidth={'500px'}>
                                                                <div className={'msg-file-inModal'}>
                                                                    {
                                                                        item.content.uploadVideoUrl ?
                                                                            <video controls
                                                                                   src={item.content.uploadVideoUrl}>
                                                                            </video>
                                                                            : ''
                                                                    }
                                                                </div>
                                                            </ZkFormItem> :
                                                            item.type == 7 ?
                                                                <ZkFormItem title={`消息${Util.toChinesNum(index + 1)}`}
                                                                            colon={true}
                                                                            titleWidth={'120px'}
                                                                            conWidth={'500px'}>
                                                                    <div className={'msg-audio-max'}>
                                                                        <div className={'msg-audio'} onClick={onPlay}>
                                                                            {
                                                                                item.content.uploadAudioUrl ?
                                                                                    <audio>
                                                                                        <source
                                                                                            src={item.content.uploadAudioUrl}/>
                                                                                        您的浏览器不支持 语音播放。
                                                                                    </audio> : ''
                                                                            }
                                                                            <img src={audioPause}
                                                                                 style={{height: '15px'}}
                                                                                 className={'audioImg'}/>
                                                                        </div>
                                                                        {
                                                                            item.content.duration ?
                                                                                <span
                                                                                    style={{fontFamily: 'auto'}}>{item.content.duration} ''
                                                                                </span>
                                                                                : ''
                                                                        }
                                                                    </div>
                                                                </ZkFormItem> :
                                                                item.type == 8 ?
                                                                    <ZkFormItem
                                                                        title={`消息${Util.toChinesNum(index + 1)}`}
                                                                        colon={true}
                                                                        titleWidth={'120px'}
                                                                        conWidth={'500px'}>
                                                                        <div style={{display: 'flex'}} key={index}>
                                                                            <div className={'im-videoHao-max'}
                                                                                 key={index} style={{
                                                                                border: 'none',
                                                                                background: '#F5F5F5'
                                                                            }}>
                                                                                <div className={'im-video-bg'}
                                                                                     style={{backgroundImage: `url(${item.content.thumb_url})`}}>
                                                                                </div>
                                                                                <div className={'im-videoHao-mid'}>
                                                                                    < img
                                                                                        src={item.content.head_img_url}/>
                                                                                    <span>{item.content.username}</span>
                                                                                </div>
                                                                                <div
                                                                                    className={'video_number_description'}>{item.content.channel_name}</div>

                                                                                <div className={'im-videoHao-divider'}>
                                                                                    <Divider/>
                                                                                </div>
                                                                                <div className={'im-videoHao-bottom'}>
                                                                                    < img src={videoHaoInmodal}/>
                                                                                    <span>{'视频号'}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </ZkFormItem> : ''
                                }
                            </div>
                        )
                    })
                }
            </div>
        </ZkModal>
    )
})
export default SendPopUp